import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { PaginatorFetcher, PaginatorFilters, TableComponent, TableConfig } from '@michelin/theme';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileSimpleDto } from 'src/app/shared/models/user/user-profile-dto';
import { UserProfileService } from 'src/app/shared/services/user-profile/user-profile.service';
import { PAGINATION_SIZES } from 'src/app/shared/utils/constants';

@Component({
    selector: 'app-list-user-profile',
    templateUrl: './list-user-profile.component.html',
    styleUrl: './list-user-profile.component.scss',
    standalone: false
})
export class ListUserProfileComponent {
  tableConfig: TableConfig<UserProfileSimpleDto> = {
    paginator: {
      pageSize: 10,
      position: 'bottom',
      pageSizeOptions: PAGINATION_SIZES
    },
    columns: {
      name: { header: 'Nome', width: '400px', sortable: true, cell: (item) => item.name },
      type: { header: 'Empresa', width: 'auto', sortable: true, cell: (item) => this.translate.instant('userTypes.' + item.userType) },
      actions: { cell: 'actionsCell', width: '70px', header: ' ' }
    }
  };

  filterForm: FormGroup = this.form.group({
    name: this.form.control(''),
    type: this.form.control('')
  });

  fetcher: PaginatorFetcher<UserProfileSimpleDto> = (filters: PaginatorFilters) => this.userProfileService.search(filters);

  @ViewChild(TableComponent, { static: true }) table: TableComponent<UserProfileSimpleDto>;

  constructor(
    private form: FormBuilder,
    private readonly router: Router,
    private userProfileService: UserProfileService,
    private translate: TranslateService
  ) {}

  get filterValues(): any {
    return {
      name: this.filterForm.value.name,
      type: this.filterForm.value.type
    };
  }

  applyFilter() {
    this.table.patchExtraFilters(this.filterValues, true);
  }

  resetFilter() {
    this.filterForm.reset();
    this.table.patchExtraFilters(this.filterValues, true);
  }

  redirectToShow(item: UserProfileSimpleDto) {
    this.router.navigate([`/user-profiles/${item.id}`]);
  }

  redirectToEdit(item: UserProfileSimpleDto) {
    this.router.navigate([`/user-profiles/${item.id}/update`]);
  }
}
